module.exports = __webpack_public_path__ + "static/WindingWorlds7-0c6dc6e224f128e5a336f77f18c097f1.png";